// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".atc-button-wrapper::-webkit-scrollbar{display:none}", ""]);
// Exports
module.exports = exports;
